import { Card, CardBody, CardTitle } from '@patternfly/react-core'
import * as React from 'react'

import { theme } from './theme'

type Props = Partial<{
  title: string
  backgroundColor: string
  subtitle: string
  value: string | number
  textColor?: string
  subtitleColor?: string
}>

export const StatusCard = ({
  title,
  value,
  subtitle,
  textColor = theme.colors.primary,
  subtitleColor = theme.colors.gray,
  backgroundColor = '#f8f8f8',
}: Props) => {
  const cardStyles: React.CSSProperties = {
    backgroundColor,
    textAlign: 'center',
    color: textColor,
    padding: '1rem',
    borderRadius: '10px',
  }

  return (
    <Card style={cardStyles}>
      <CardTitle>{title}</CardTitle>
      <CardBody>
        <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>{value}</div>
        <div
          style={{
            fontSize: '1rem',
            color: subtitleColor,
          }}
        >
          {subtitle}
        </div>
      </CardBody>
    </Card>
  )
}
